export const getters = {

}



// WEBPACK FOOTER //
// ./src/store/modules/Office/getters.js